import { resolveProgrammeProgress } from './programmeProgress';

const reviewEntry = (uid, details) => ({
  key: `${uid}:review`,
  label: 'Da verificare',
  state: 'review',
  details,
  expiresAt: null,
  fraction: null,
});

// Keep the ticket badge on the monitor's current programme, including renewals
// and manual unlocks. A purchase deadline alone does not prove an active programme.
export function resolveTicketProgrammeStatus({ uid, percorsi, products = [], user, now = new Date() } = {}) {
  const userId = String(uid || '').trim();
  if (!userId || !user || typeof user !== 'object' || Array.isArray(user)) {
    return [reviewEntry(userId, 'Profilo utente non disponibile: verifica lo stato del programma nel profilo.')];
  }
  if (!Array.isArray(percorsi)) {
    return [reviewEntry(userId, 'Percorsi non disponibili: verifica lo stato del programma nel profilo.')];
  }
  if (!percorsi.length) {
    return [{
      key: `${userId}:none`,
      label: 'Nessun programma',
      state: 'none',
      details: 'Nessun percorso presente nel profilo utente.',
      expiresAt: null,
      fraction: null,
    }];
  }

  const progress = resolveProgrammeProgress({ uid: userId, percorsi, products, user, now });
  return progress.entries.map(entry => {
    const record = entry.record;
    if (!record) return reviewEntry(userId, entry.details.join('\n'));
    const expiresAt = record.expiresAt || record.expireAt || null;
    let state = 'review';
    let label = 'Da verificare';
    if (record.state === 'completed') {
      state = 'completed';
      label = 'Completato';
    } else if (record.state === 'hold') {
      state = 'hold';
      label = 'Sospeso';
    } else if (record.state === 'waiting') {
      state = 'waiting';
      label = 'Da iniziare';
    } else if (record.state === 'started' && expiresAt) {
      state = record.expired ? 'expired' : 'active';
      label = record.expired ? 'Scaduto' : 'Attivo';
    }
    const details = [`Stato programma: ${label}`, ...entry.details];
    if (record.state !== 'completed') {
      details.push(record.delivered ? 'Programma consegnato' : 'Programma non ancora consegnato');
    }
    if (record.state === 'started' && !expiresAt) {
      details.push('La scadenza del programma avviato non è verificabile.');
    }
    if (record.state === 'waiting' && record.expired) {
      details.push('Data pianificata superata: il programma non risulta ancora avviato.');
    }
    return {
      key: entry.key,
      label,
      state,
      details: details.join('\n'),
      expiresAt,
      fraction: record.validFraction ? record.fraction : null,
    };
  });
}
